var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4492 1.42505L15.5742 3.55005L13.9542 5.17072L11.8292 3.04572L13.4492 1.42505ZM5.66602 11.3332H7.79102L12.9526 6.17159L10.8276 4.04659L5.66602 9.20822V11.3332Z",
    fill: "url(#paint0_linear_5131_13562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 13.4583H5.77858C5.76017 13.4583 5.74104 13.4654 5.72263 13.4654C5.69925 13.4654 5.67587 13.459 5.65179 13.4583H3.54167V3.54167H8.39162L9.80829 2.125H3.54167C2.76037 2.125 2.125 2.75967 2.125 3.54167V13.4583C2.125 14.2403 2.76037 14.875 3.54167 14.875H13.4583C13.8341 14.875 14.1944 14.7257 14.4601 14.4601C14.7257 14.1944 14.875 13.8341 14.875 13.4583V7.3185L13.4583 8.73517V13.4583Z",
    fill: "url(#paint1_linear_5131_13562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_13562",
    x1: 5.66602,
    y1: 1.42505,
    x2: 15.7762,
    y2: 1.63566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5131_13562",
    x1: 2.125,
    y1: 2.125,
    x2: 15.135,
    y2: 2.39601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsEdit);
export default __webpack_public_path__ + "static/media/cs-edit.4f82cc15c4bc665079d7d355a58ea98f.svg";
export { ForwardRef as ReactComponent };